import FactureRèglementLine from "./FactureRèglementLine";
import { integerCentToFrenchFinanString } from "vincent-utils";
import type { ExistingFacture3 } from "compta-shared";
import DateDisplayerComp from "../../utils/components/DateDisplayerComp.tsx";
import RapprochéBadge from "./RapprochéBadge.tsx";
import ModeBadge from "./ModeBadge.tsx";

interface FactureCompProps {
  facture: ExistingFacture3;
  onFactureClicked: (factureId: string) => void;
  showModeBadge?: boolean;
}

const FactureComp = (props: FactureCompProps) => {
  const { facture, onFactureClicked, showModeBadge } = props;
  const { libellé, date, banqueId, mode } = facture;
  const { règlements } = facture;
  const factureReference =
    facture.mode === "Chèque1"
      ? facture.chequeNumber || facture.modeRef || ""
      : facture.modeRef || "";
  const reglComps = règlements
    ? règlements.map((regl, idx) => (
        <FactureRèglementLine
          key={idx + "reglComps"}
          montant={integerCentToFrenchFinanString(regl.montantCent)}
          date={regl.date}
          banqueId={regl.banqueId || ""}
        />
      ))
    : null;
  return (
    <div
      onClick={() => onFactureClicked(facture._id)}
      style={{ cursor: "pointer" }}
      className="row"
    >
      <div className="col-2">
        {date ? <DateDisplayerComp date={date} /> : ""}
      </div>
      <div className="col-2">{libellé} </div>
      <div className="col-1">
        {integerCentToFrenchFinanString(facture.montantCent)}
      </div>
      <div className="col-2">
        {showModeBadge ? <ModeBadge mode={mode} /> : mode || ""}
      </div>
      <div className="col-2">{factureReference} </div>
      <div className="col-1">
        {règlements.length === 0 ? (
          <RapprochéBadge isRapproché={!!banqueId} />
        ) : (
          ""
        )}
      </div>
      <div className="col-1">{reglComps}</div>
    </div>
  );
};

export default FactureComp;
